import React, { useEffect, useState } from "react";
import "./styles.css";
import { Container, Table } from "react-bootstrap";
import LoadingPage from "../../Components/LoadingPage/LoadingPage";
import { BLANK_STRING } from "../../constants/appConstants";
import { useNavigate, useParams } from "react-router-dom";
import { getInternalAuditDataAPI } from "../../apiRequests/internal-audit/getInternalAuditDataAPI";

interface InternalAuditProps {
    isDashboard?: boolean;
    dataIAs?: any;
}

const InternalAudit = (props: InternalAuditProps) => {
    const navigate = useNavigate();
    const { year } = useParams();
    const [dataIAs, setDataIAs] = useState<any>([]);

    const [selectedYear, setSelectedYear] = useState<string>(BLANK_STRING);

    useEffect(() => {
        !props.isDashboard && getIADataAndSetToState();
    }, []);

    useEffect(() => {
        if (selectedYear) {
            !props.isDashboard && navigate(`/internal-audit/${exportYear(selectedYear)}`, { replace: true });
        }
    }, [selectedYear]);

    useEffect(() => {
        if (dataIAs.length) {
            setCurrentYearAndQuarter();
        }
    }, [year, dataIAs]);

    useEffect(() => {
        if (props.isDashboard) {
            setDataIAs(props.dataIAs);
        }
    }, [props.dataIAs, props.isDashboard]);

    const exportYear = (yearString: string) => {
        const match = yearString.match(/\d{4}/);
        const year = match ? match[0] : null;
        return year;
    };

    const setCurrentYearAndQuarter = () => {
        if (year) {
            const currentIA = dataIAs.find((data: any) => {
                return exportYear(data.title) === year.toString();
            });
            setSelectedYear(currentIA?.title || BLANK_STRING);
        } else {
            const currentYear = new Date().getFullYear();
            const currentIA = dataIAs.find((data: any) => {
                return exportYear(data.title) === currentYear.toString();
            });
            setSelectedYear(currentIA?.title || BLANK_STRING);
            !props.isDashboard && navigate(`/internal-audit/${currentYear}`, { replace: true });
        }
    };

    const getIADataAndSetToState = async () => {
        const dataIAs: any = await getInternalAuditDataAPI();
        setDataIAs(dataIAs);
    };

    const renderSelectIAsYear = () => {
        return (
            <div className="selector-container">
                <label className="label" htmlFor="year">
                    Select Year:
                </label>
                <select
                    className="select"
                    id="year"
                    value={selectedYear}
                    onChange={(event) => {
                        setSelectedYear(event.target.value);
                    }}
                >
                    <option disabled value="">
                        Select Year
                    </option>
                    {dataIAs.map((data: any) => {
                        return (
                            <option key={data.title} value={data.title}>
                                {data.title}
                            </option>
                        );
                    })}
                </select>
            </div>
        );
    };

    const renderIAsDataTable = () => {
        const dataIAsInSelectedYear = dataIAs.find((data: any) => {
            return data.title === selectedYear;
        });

        return (
            <>
                <p>Number of Internal Audit Report: {dataIAsInSelectedYear.data.length}</p>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>ID</th>
                            <th>TITLE</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataIAsInSelectedYear.data.map((data: any, index: number) => {
                            return (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{data.id}</td>
                                    <td>
                                        <a href={data.link} target="_blank">
                                            {data.title}
                                        </a>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </>
        );
    };

    const renderLoading = () => {
        return <LoadingPage></LoadingPage>;
    };

    const renderMainContentOfInternalAudit = () => {
        return (
            <>
                {renderSelectIAsYear()}
                {selectedYear && renderIAsDataTable()}
            </>
        );
    };
    return <Container>{dataIAs.length ? renderMainContentOfInternalAudit() : renderLoading()}</Container>;
};

export default InternalAudit;
